import stateStore from "../../store/stateStore";
import { getSearchName, setValueByKey } from "../../util/directive-utils";
import { isNotEmpty } from "../../util/util";

export const searchFormMap = {
    "tokuisaki": {
        "modal": {
            component: "Inff001",
            title: "得意先コード照会",
            size: "lg",
            params: function () {
                return {
                };
            }
        },
        "multi-modal": {
            component: "Inff001",
            title: "複数範囲指定画面",
            size: "ssm",
            params: function () {
                return {
                    "JKENKBN": ''
                };
            }
        },
        "form": function (scope, attr, asyncService, GyCtrl, inputdata, errMsgService, addArgs) {
            // TODO dummy data
            const data = {
                "tksakicd": '123', "tksaksskimei": 'test', "row": '1'
            }
            if (inputdata === data.tksakicd) {
                setValueByKey(attr.name, stateStore.state, inputdata);
                // 取得したデータを保持
                // setValueByKey("gyData." + attr.name, stateStore.state, data.row);
                // searchnameの値がnemeの値と一致する要素のng-modelを取得
                const searchNameNgModel = getSearchName(attr.name);
                if (isNotEmpty(searchNameNgModel)) {
                    setValueByKey(searchNameNgModel, stateStore.state, data[searchNameNgModel]);
                }
            }

        }
    },
    "test": {
        "modal": {
            component: "Inff001",
            title: "得意先コード照会",
            size: "lg",
            params: function () {
                return {
                };
            },
            footerOptions : {
                detailBtn: true,
                clearBtn: true,
                commitBtn: true,
                endBtnFunc: null,
            }
        },
        "multi-modal": {
            component: "Inff001",
            title: "複数範囲指定画面",
            size: "ssm",
            params: function () {
                return {
                    "JKENKBN": ''
                };
            }
        },
        "form": function (scope, attr, asyncService, GyCtrl, inputdata, errMsgService, addArgs) {
            // TODO dummy data
            const data = {
                "tksakicd": '123', "tksaksskimei": 'test', "row": '1'
            }
            if (inputdata === data.tksakicd) {
                setValueByKey(attr.name, stateStore.state, inputdata);
                // 取得したデータを保持
                // setValueByKey("gyData." + attr.name, stateStore.state, data.row);
                // searchnameの値がnemeの値と一致する要素のng-modelを取得
                const searchNameNgModel = getSearchName(attr.name);
                if (isNotEmpty(searchNameNgModel)) {
                    setValueByKey(searchNameNgModel, stateStore.state, data[searchNameNgModel]);
                }
            }

        }
    },
}

export default searchFormMap;